module.exports = __webpack_public_path__ + "img/section.092dc148.svg";